<template>
	<j-base-select
		:id="id"
		:options="options"
		:value="value"
		:placeholder="$t('select_insurance_type')"
		:allowSelectNothing="false"
		:status="status"
		:size="size"
		@input="onInput($event)"
	/>
</template>

<script>
/**
 * This component is reposnible for displaying insurenace type available to tenant
 * It gets the types from tenant settings for now. Later on, it will be fetched
 * @returns id of insurance type
 */
import JBaseSelect from "@/components/JBaseSelect"
import api from "../api/"

export default {
	components: { JBaseSelect },
	props: {
		value: {
			validator(value) {
				return value === null || typeof value === "string"
			},
			required: true,
			default: null
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			default: "medium"
		}
	},
	data() {
		return {
			insuranceTypes: [],
			options: []
		}
	},
	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		// Fetch productTypes and map to options
		async readAllInsuranceTypes() {
			const res = await api.insuranceTypes()
			this.options = res.data.productTypes.map(item => ({
				name: item.name,
				value: item.typeId
			}))

			this.options.sort((a, b) => {
				let nameA = a.name.toUpperCase()
				let nameB = b.name.toUpperCase()

				if (nameA < nameB) return -1
				if (nameA > nameB) return 1

				return 0
			})
		}
	},
	created() {
		this.readAllInsuranceTypes()
	}
}
</script>
